import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, } from 'react-bootstrap';
import { Input, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';

const SettingsForm = ({ error, pristine, submitting, submitSucceeded, t, initialValues, kindergartenPayment}) => {
	return (
		<Form>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='lessonDate' component={Static} formatType={'date'} type='text' label={t('KindergartenAttendance_LessonDate')} />
			<Field name='childrenCount' component={Input} required type='text' label={t('KindergartenAttendance_ChildrenCount')} validate={[validators.required, validators.number]} />
			<Field name='total' component={Input} required type='text' label={t('KindergartenAttendance_Total')} validate={[validators.required, validators.number]} />
		</Form>
	);
};

export default reduxForm({ form: 'kindergartenPaymentDetailForm' })(SettingsForm);